export default __webpack_public_path__ + "408f264d899354f8248236c6f423c013.webp";